import type { User } from '@/types'
import type { Company } from '@/types/company'
import { CompanyUserRole } from '@/types/companyUser'
import { UserType } from '@/types/user'
import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatDate(date: Date | null | undefined): string {
  if (!date) return ''
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  }).format(date)
}

export function canManageUsers(userType?: CompanyUserRole): boolean {
  return userType === CompanyUserRole.ADMIN || userType === CompanyUserRole.SUPER_ADMIN
}

export function canCreatePost(user: User, userRole?: CompanyUserRole | null, company?: Company | null): boolean {
  if (user.active === false) return false

  // Super admins cannot create posts - they are for monitoring only
  if (user.userType === UserType.SUPER_ADMIN || user.isRoot) return false

  // If company is disabled, no one else can create posts
  if (company && company.status === false) return false

  if (user.canPost) return true

  if (userRole) {
    return [
      CompanyUserRole.ADMIN,
      CompanyUserRole.SUPER_ADMIN,
      CompanyUserRole.PR_MANAGER,
      CompanyUserRole.PR_MEMBER,
    ].includes(userRole)
  }

  return false
}
